export default "__VITE_ASSET__CRb93Kbt__"